import routerOptions0 from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.20.1_@biomejs+biome@1.9.4_@parcel+watcher@2.5.6_@types+node@25.2.0_@vue+compiler_4fec32bc0d99de289ee444ae28af1a32/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/opt/buildhome/repo/src/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions1.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}